// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"21":"SectionMethods","97":"Footer","579":"Section3","855":"Section2"}[chunkId] || chunkId) + ".js";
};